var AdobeAn;
import 'latest-createjs';

(function (cjs, an) {

    var p; // shortcut to reference prototypes
    var lib={};var ss={};var img={};
    lib.ssMetadata = [];


// symbols:



    (lib.Bitmap1 = function() {
        this.initialize(img.Bitmap1);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0,0,560,575);


    (lib.Bitmap1_1 = function() {
        this.initialize(img.Bitmap1_1);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0,0,771,614);


    (lib.cherep1 = function() {
        this.initialize(img.cherep1);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0,0,59,64);


    (lib.cherep2 = function() {
        this.initialize(img.cherep2);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0,0,57,65);


    (lib.cherep3 = function() {
        this.initialize(img.cherep3);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0,0,57,63);


    (lib.cherep4 = function() {
        this.initialize(img.cherep4);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0,0,118,156);


    (lib.granata = function() {
        this.initialize(img.granata);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0,0,310,346);


    (lib.Mask_fox = function() {
        this.initialize(img.Mask_fox);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0,0,468,523);// helper functions:

    function mc_symbol_clone() {
        var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
        clone.gotoAndStop(this.currentFrame);
        clone.paused = this.paused;
        clone.framerate = this.framerate;
        return clone;
    }

    function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
        var prototype = cjs.extend(symbol, cjs.MovieClip);
        prototype.clone = mc_symbol_clone;
        prototype.nominalBounds = nominalBounds;
        prototype.frameBounds = frameBounds;
        return prototype;
    }


    (lib.shapes7 = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics.beginFill("#1D1D1D").beginStroke().moveTo(22,59.9).curveTo(17.8,52.5,14.4,36.7).curveTo(10.1,16.8,9,13.5).curveTo(5.5,2.9,-0.3,2.9).curveTo(-3.7,2.9,-6.7,4.8).curveTo(-8.5,6,-12.2,9).curveTo(-20.6,15.1,-34.4,15.1).curveTo(-40,15.1,-42.2,9.3).curveTo(-44.5,3.4,-44.1,-0.2).curveTo(-43.7,-3.8,-41.3,-10.2).curveTo(-38.9,-16.7,-38.9,-22.3).curveTo(-38.9,-26.9,-42.5,-29).curveTo(-44.7,-30.3,-50.6,-32.1).curveTo(-55.9,-34.3,-58.6,-38.3).curveTo(-62.3,-43.8,-62.3,-54.3).curveTo(-62.2,-66.4,-50.6,-69.5).curveTo(-41,-72,-29.2,-68.1).curveTo(-23.7,-64.4,-17.3,-60.9).curveTo(-4.5,-54.1,5.3,-54.1).curveTo(9.5,-54.1,26.2,-55.4).curveTo(36.4,-55.4,43.9,-44.8).curveTo(51.8,-33.5,51.8,-16.2).curveTo(51.7,-12.1,51.2,-10.1).lineTo(50.2,-7.1).curveTo(48.5,-2.8,48.5,11.6).curveTo(48.5,17.5,50.6,22).curveTo(52,24.8,55.4,28.9).curveTo(58.9,33.1,60.1,35.4).curveTo(62.2,39.6,62.2,45).curveTo(62.2,53.7,57.2,60.9).curveTo(50.5,70.4,37.8,70.4).curveTo(27.9,70.4,22,59.9).closePath();
        this.shape.setTransform(-17.4,12.8117);

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    }).prototype = getMCSymbolPrototype(lib.shapes7, new cjs.Rectangle(-79.6,-57.6,124.5,140.9), null);


    (lib.ptrn6_m = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.instance = new lib.Bitmap1_1();
        this.instance.parent = this;
        this.instance.setTransform(-385,-307);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.ptrn6_m, new cjs.Rectangle(-385,-307,771,614), null);


    (lib.ptrn4_mow = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.instance = new lib.Bitmap1();
        this.instance.parent = this;
        this.instance.setTransform(-280,-288);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.ptrn4_mow, new cjs.Rectangle(-280,-288,560,575), null);


    (lib.maska = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.instance = new lib.Mask_fox();
        this.instance.parent = this;
        this.instance.setTransform(-234,-261.5);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.maska, new cjs.Rectangle(-234,-261.5,468,523), null);


    (lib.granata_in = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.instance = new lib.granata();
        this.instance.parent = this;
        this.instance.setTransform(-69,-301);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.granata_in, new cjs.Rectangle(-69,-301,310,346), null);


    (lib.cherep4_1 = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.instance = new lib.cherep4();
        this.instance.parent = this;
        this.instance.setTransform(-59,-78);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.cherep4_1, new cjs.Rectangle(-59,-78,118,156), null);


    (lib.cherep3_1 = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.instance = new lib.cherep3();
        this.instance.parent = this;
        this.instance.setTransform(-28.5,-31.5);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.cherep3_1, new cjs.Rectangle(-28.5,-31.5,57,63), null);


    (lib.cherep2_1 = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.instance = new lib.cherep2();
        this.instance.parent = this;
        this.instance.setTransform(-28.5,-32.5);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.cherep2_1, new cjs.Rectangle(-28.5,-32.5,57,65), null);


    (lib.cherep1_1 = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.instance = new lib.cherep1();
        this.instance.parent = this;
        this.instance.setTransform(-29.5,-32);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.cherep1_1, new cjs.Rectangle(-29.5,-32,59,64), null);


    (lib.letter_02_L = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics.beginFill('#FF4D52').beginStroke().moveTo(31.3, 142.9).lineTo(31.3, 103.3).lineTo(57.1, 103.3).lineTo(57.1, 13.1).lineTo(-57.2, 13.1).lineTo(-57.2, 103.3).lineTo(-31, 103.3).lineTo(-31, 142.9).lineTo(-145.9, 142.9).lineTo(-145.9, 103.3).lineTo(-116.8, 103.3).lineTo(-116.8, -103.3).lineTo(-145.9, -103.3).lineTo(-145.9, -142.9).lineTo(-31, -142.9).lineTo(-31, -103.3).lineTo(-57.2, -103.3).lineTo(-57.2, -24.3).lineTo(57.1, -24.3).lineTo(57.1, -103.3).lineTo(31.3, -103.3).lineTo(31.3, -142.9).lineTo(145.8, -142.9).lineTo(145.8, -103.3).lineTo(117, -103.3).lineTo(117, 103.3).lineTo(145.8, 103.3).lineTo(145.8, 142.9).closePath();
        this.shape.setTransform(-0.2, -38.9);

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    }).prototype = getMCSymbolPrototype(lib.letter_02_L, new cjs.Rectangle(-165.5, -210, 331.1, 420), null);


    (lib.pattern6 = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.pt = new lib.ptrn6_m();
        this.pt.name = "pt";
        this.pt.parent = this;

        this.timeline.addTween(cjs.Tween.get(this.pt).wait(1));

    }).prototype = getMCSymbolPrototype(lib.pattern6, new cjs.Rectangle(-385,-307,771,614), null);


    (lib.ptrn4 = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.pt = new lib.ptrn4_mow();
        this.pt.name = "pt";
        this.pt.parent = this;
        this.pt.setTransform(0,0.5);
        this.pt.cache(-282,-290,564,579);

        this.timeline.addTween(cjs.Tween.get(this.pt).wait(1));

    }).prototype = getMCSymbolPrototype(lib.ptrn4, new cjs.Rectangle(-280,-287.5,560,575), null);


    (lib.granata_1 = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.granata_in = new lib.granata_in();
        this.granata_in.name = "granata_in";
        this.granata_in.parent = this;
        this.granata_in.setTransform(-4,1);

        this.timeline.addTween(cjs.Tween.get(this.granata_in).wait(1));

    }).prototype = getMCSymbolPrototype(lib.granata_1, new cjs.Rectangle(-73,-300,310,346), null);


    (lib.letter = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // letter1
        this.letter1 = new lib.letter_02_L();
        this.letter1.name = "letter1";
        this.letter1.parent = this;

        this.timeline.addTween(cjs.Tween.get(this.letter1).wait(1));

        // letter2
        this.letter2 = new lib.letter_02_L();
        this.letter2.name = "letter2";
        this.letter2.parent = this;
        this.letter2.setTransform(0, 0, 0.9, 0.9);
        this.letter2.filters = [new cjs.ColorFilter(0.7, 0.7, 0.7, 1, 0, 0, 0, 0)];
        this.letter2.cache(-167, -212, 335, 424);

        this.timeline.addTween(cjs.Tween.get(this.letter2).wait(1));

        // letter3
        this.letter3 = new lib.letter_02_L();
        this.letter3.name = "letter3";
        this.letter3.parent = this;
        this.letter3.setTransform(0, 0, 0.8, 0.8);
        this.letter3.filters = [new cjs.ColorFilter(0.51, 0.51, 0.51, 1, 0, 0, 0, 0)];
        this.letter3.cache(-167, -212, 335, 424);

        this.timeline.addTween(cjs.Tween.get(this.letter3).wait(1));

        // letter4
        this.letter4 = new lib.letter_02_L();
        this.letter4.name = "letter4";
        this.letter4.parent = this;
        this.letter4.setTransform(0, 0, 0.7, 0.7);
        this.letter4.filters = [new cjs.ColorFilter(0.21, 0.21, 0.21, 1, 0, 0, 0, 0)];
        this.letter4.cache(-167, -212, 335, 424);

        this.timeline.addTween(cjs.Tween.get(this.letter4).wait(1));

        // letter5
        this.letter5 = new lib.letter_02_L();
        this.letter5.name = "letter5";
        this.letter5.parent = this;
        this.letter5.setTransform(0, 0, 0.6, 0.6);
        this.letter5.filters = [new cjs.ColorFilter(0, 0, 0, 1, 0, 0, 0, 0)];
        this.letter5.cache(-167, -212, 335, 424);

        this.timeline.addTween(cjs.Tween.get(this.letter5).wait(1));

    }).prototype = getMCSymbolPrototype(lib.letter, new cjs.Rectangle(-165.5, -210, 331.1, 420), null);


    (lib.jul = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Mask_fox.png
        this.masca = new lib.maska();
        this.masca.name = "masca";
        this.masca.parent = this;
        this.masca.setTransform(-303,-123.5);

        this.timeline.addTween(cjs.Tween.get(this.masca).wait(1));

        // granata.png
        this.granata = new lib.granata_1();
        this.granata.name = "granata";
        this.granata.parent = this;
        this.granata.setTransform(-292.95, 138.05, 0.88, 0.88);

        this.timeline.addTween(cjs.Tween.get(this.granata).wait(1));

        // cherep4.png
        this.sh4 = new lib.cherep4_1();
        this.sh4.name = "sh4";
        this.sh4.parent = this;
        this.sh4.setTransform(-354,189);

        this.timeline.addTween(cjs.Tween.get(this.sh4).wait(1));

        // cherep3.png
        this.sh3 = new lib.cherep3_1();
        this.sh3.name = "sh3";
        this.sh3.parent = this;
        this.sh3.setTransform(-484.5,183.5);

        this.timeline.addTween(cjs.Tween.get(this.sh3).wait(1));

        // cherep2.png
        this.sh2 = new lib.cherep2_1();
        this.sh2.name = "sh2";
        this.sh2.parent = this;
        this.sh2.setTransform(-462.5,86.5);

        this.timeline.addTween(cjs.Tween.get(this.sh2).wait(1));

        // cherep1.png
        this.sh1 = new lib.cherep1_1();
        this.sh1.name = "sh1";
        this.sh1.parent = this;
        this.sh1.setTransform(-37.5,-144);

        this.timeline.addTween(cjs.Tween.get(this.sh1).wait(1));

        // Layer_2
        this.letter = new lib.letter();
        this.letter.name = "letter";
        this.letter.parent = this;
        this.letter.setTransform(38.05,40);

        this.timeline.addTween(cjs.Tween.get(this.letter).wait(1));

        // shapes7
        this.s1 = new lib.shapes7();
        this.s1.name = "s1";
        this.s1.parent = this;
        this.s1.setTransform(-588.1,-336.05,1,1,-83.9757,0,0,2.8,-0.1);

        this.timeline.addTween(cjs.Tween.get(this.s1).wait(1));

        // shapes6 (mask)
        var mask = new cjs.Shape();
        mask._off = true;
        mask.graphics.moveTo(-124,147.3).curveTo(-142.8,142.8,-152.6,129.8).lineTo(-152.6,129.8).curveTo(-162,117.5,-162,98.6).lineTo(-162,98.6).curveTo(-162,94,-161.5,89).lineTo(-161.5,89).curveTo(-156.5,44.1,-136.7,23.8).lineTo(-136.7,23.8).curveTo(-131.8,18.8,-118.8,11.3).lineTo(-118.8,11.3).curveTo(-105.7,3.8,-94.4,-9.8).lineTo(-94.4,-9.8).curveTo(-83.1,-23.5,-81,-60.5).lineTo(-81,-60.5).curveTo(-78.9,-97.5,-70.5,-113).lineTo(-70.5,-113).curveTo(-64.7,-123.5,-52.9,-132.2).lineTo(-52.9,-132.2).curveTo(-40.8,-141.1,-25.4,-145.7).lineTo(-25.4,-145.7).curveTo(-8.7,-150.6,8.4,-149.3).lineTo(8.4,-149.3).curveTo(27.3,-147.9,44.5,-139).lineTo(44.5,-139).curveTo(60,-130.9,80.4,-125.7).lineTo(80.4,-125.7).curveTo(84.6,-124.6,113.7,-118.6).lineTo(113.7,-118.6).curveTo(131.8,-114.8,140.9,-110.6).lineTo(140.9,-110.6).curveTo(153.2,-104.8,158.5,-94.5).lineTo(158.5,-94.5).curveTo(162,-87.6,162,-81.8).lineTo(162,-81.8).curveTo(162,-79.1,161.3,-76.7).lineTo(161.3,-76.7).curveTo(159.4,-70.3,151.8,-64.4).lineTo(151.8,-64.4).curveTo(147.5,-61.1,136.1,-54.6).lineTo(136.1,-54.6).curveTo(125.2,-48.4,120.5,-44.5).lineTo(120.5,-44.5).curveTo(114.7,-39.7,111.9,-31.9).lineTo(111.9,-31.9).lineTo(108.1,-17.7).lineTo(108.1,-17.7).curveTo(105.6,-8.9,101.3,-3.3).lineTo(101.3,-3.3).curveTo(95.4,4.2,84,9.5).lineTo(84,9.5).curveTo(74.8,13.8,65,11.2).lineTo(65,11.2).curveTo(60.8,10.1,48.5,4.1).lineTo(48.5,4.1).curveTo(38.5,-0.9,31.9,-1).lineTo(31.9,-1).curveTo(22.3,-1.2,12.5,7).lineTo(12.5,7).curveTo(5.3,13.1,5.3,23.4).lineTo(5.3,23.4).curveTo(5.3,25.1,5.5,26.9).lineTo(5.5,26.9).curveTo(6.1,31.6,8.2,38.7).lineTo(8.2,38.7).curveTo(9.4,42.7,12.1,51).lineTo(12.1,51).curveTo(15.4,62,15.4,69.7).lineTo(15.4,69.7).curveTo(15.4,72.9,14.8,75.5).lineTo(14.8,75.5).curveTo(12.1,88.4,-3.5,96.5).lineTo(-3.5,96.5).curveTo(-37,114.1,-47.4,122.4).lineTo(-47.4,122.4).curveTo(-50.2,124.6,-55.7,130).lineTo(-55.7,130).curveTo(-61.2,135.4,-67,140).lineTo(-67,140).curveTo(-74.3,145.9,-90.5,148.4).lineTo(-90.5,148.4).curveTo(-97.8,149.6,-104.9,149.6).lineTo(-104.9,149.6).curveTo(-114.7,149.6,-124,147.3).closePath();
        mask.setTransform(-524.2554,-225.4293);

        // Layer_9
        this.p2 = new lib.pattern6();
        this.p2.name = "p2";
        this.p2.parent = this;
        this.p2.setTransform(-445.95,-219.95,1,1,180);

        var maskedShapeInstanceList = [this.p2];

        for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask;
        }

        this.timeline.addTween(cjs.Tween.get(this.p2).wait(1));

        // shapes8 (mask)
        var mask_1 = new cjs.Shape();
        mask_1._off = true;
        mask_1.graphics.moveTo(-101.7,91.9).curveTo(-141.5,63.6,-124,8.2).curveTo(-106.6,-28,-78.8,-46.9).curveTo(-51,-65.7,-24,-69.5).curveTo(3.1,-73.2,27.3,-110.7).curveTo(51.5,-148.1,83.9,-140.5).curveTo(116.4,-132.9,127.1,-94.6).curveTo(136.1,-62.4,109.4,-39.4).curveTo(89.5,-22.3,68.1,-21.2).curveTo(46.7,-20,54.1,14.6).curveTo(61.4,49.3,9.1,91.5).curveTo(-17.3,112.7,-45.1,112.7).curveTo(-72.7,112.7,-101.7,91.9).closePath();
        mask_1.setTransform(-39.7169,-141.7919);

        // Layer_7
        this.p3 = new lib.ptrn4();
        this.p3.name = "p3";
        this.p3.parent = this;
        this.p3.setTransform(-46.05,-141.5);

        var maskedShapeInstanceList = [this.p3];

        for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask_1;
        }

        this.timeline.addTween(cjs.Tween.get(this.p3).wait(1));

    }).prototype = getMCSymbolPrototype(lib.jul, new cjs.Rectangle(-686.3, -385, 889.9, 652), null);


// stage content:
    (lib._07 = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});
        /*
        // timeline functions:
        this.frame_0 = function() {
            var tl = new TimelineMax();
         var tl2 = new TimelineMax();

         var time=0.31;
         var yb=0; // y begin
         var xb=-10; // x begin
         var xO=70;// x stop

         var x5=((xO-xb)/4)*(0)+xb;
         var x4=((xO-xb)/4)*(1)+xb;
         var x3=((xO-xb)/4)*(2)+xb;
         var x2=((xO-xb)/4)*(3)+xb;
         var x1=((xO-xb)/4)*(4)+xb;


         tl.set(this.jul, {x:750, y:610});
         // granata
         tl.set(this.jul.granata, {x:-230, y:214, scaleX:0.9, scaleY:0.9,alpha:1}, "start");
         tl.to(this.jul.granata, 2, {x:-134, y:244, scaleX:1, scaleY:1,alpha:1 ,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1") }, "start+=0.5" )
         tl2.set(this.jul.granata.granata_in, {rotation:-10, ease:Linear.easeNone}, "start");
         tl2.to(this.jul.granata.granata_in ,  3, {rotation:0, repeat:-1 ,yoyo:true}, "start")

         // masca
         tl.set(this.jul.masca, {x:-400, y:-190, scaleX:0, scaleY:0,rotation:-40,alpha:1}, "start");
         tl.to(this.jul.masca, 2, {x:-303, y:-123, scaleX:1, scaleY:1,rotation:0,alpha:1 ,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1") }, "start+=0.9" )

         // sh1 sh2 sh3 sh4
         tl.set(this.jul.sh1, {x:-400, y:-190, scaleX:0, scaleY:0,alpha:1}, "start");
         tl.to(this.jul.sh1, 2, {x:-37, y:-144, scaleX:1, scaleY:1,alpha:1 ,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1") }, "start+=0.9" )

         tl.set(this.jul.sh2, {x:-400, y:-190, scaleX:0, scaleY:0,alpha:1}, "start");
         tl.to(this.jul.sh2, 2, {x:-462, y:86, scaleX:1, scaleY:1,alpha:1 ,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1") }, "start+=1.2" )

         tl.set(this.jul.sh3, {x:-400, y:-190, scaleX:0, scaleY:0,alpha:1}, "start");
         tl.to(this.jul.sh3, 2, {x:-484, y:-183, scaleX:1, scaleY:1,alpha:1 ,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1") }, "start+=1" )

         tl.set(this.jul.sh4, {x:-400, y:-190, scaleX:0, scaleY:0,alpha:1}, "start");
         tl.to(this.jul.sh4, 2, {x:-354, y:190, scaleX:1, scaleY:1,alpha:1 ,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1") }, "start+=1.4" )


         // s1
         tl.set(this.jul.s1, {x:-288, y:-5, scaleX:0, scaleY:0,rotation:-84}, "start");
         tl.to(this.jul.s1,  2, {x:-588, y:-333, scaleX:1, scaleY:1,rotation:-84, ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1") }, "start+=0.9")



         // s2
         tl.set(this.jul.p2.mask, {x:-0, y:100, scaleX:0, scaleY:0 }, "start");
         tl.to(this.jul.p2.mask, 3, {x:-524, y:-222, scaleX:1, scaleY:1 , ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1") }, "start+=0.9")

         // p2


         tl.set(this.jul.p2, {x:-0, y:100, scaleX:1, scaleY:1}, "start");
         tl.to(this.jul.p2,  4, {x:-445, y:-219, scaleX:1, scaleY:1,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1") }, "start+=0.9")



         // s3
         tl.set(this.jul.p3.mask, {x:-4, y:0, scaleX:0, scaleY:0},"start");
         tl.to(this.jul.p3.mask,  3.7, {x:-41, y:-162, scaleX:1, scaleY:1,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1") }, "start+=0.9")
         // p3
         tl.set(this.jul.p3, {x:5, y:-97, scaleX:1, scaleY:1}, "start");
         tl.to(this.jul.p3,  0.7, {x:21, y:-135, scaleX:1, scaleY:1,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1") }, "start+=0.9")
         tl2.set(this.jul.p3.pt, {rotation:0, ease:Linear.easeNone}, "start");
         tl2.to(this.jul.p3.pt ,  90, {rotation:360,repeat:-1 ,ease:Linear.easeNone}, "start")

         // ------------ litter---------


         tl.set(this.jul.letter.letter1, {x:x1, y:yb, alpha:0,}, "start");
         tl.to(this.jul.letter.letter1 ,  time+0.4, {x:x1, y:yb, alpha:1,ease: CustomEase.create("custom", "M0,0 C0.022,0.068 0.11,0.478 0.246,0.63 0.367,0.765 0.422,0.85 1,1")}, "start+=0.9")

         tl.set(this.jul.letter.letter2, {x:x2, y:yb, alpha:0}, "start");
         tl.to(this.jul.letter.letter2 ,  time+0.4, {x:x2, y:yb, alpha:1,ease: CustomEase.create("custom", "M0,0 C0.026,0.136 0.064,0.548 0.2,0.7 0.321,0.835 0.406,0.902 1,1")}, "start+=0.8")
         tl.to(this.jul.letter.letter2 ,  time+0.3, {alpha:0}, "start+=0.98")

         tl.set(this.jul.letter.letter3, {x:x3, y:yb, alpha:0}, "start");
         tl.to(this.jul.letter.letter3 ,  time+0.2, {x:x3, y:yb, alpha:1,ease: CustomEase.create("custom", "M0,0,C0,0.27,0.028,0.626,0.164,0.778,0.285,0.913,0.422,0.974,1,1")}, "start+=0.7")
         tl.to(this.jul.letter.letter3 ,  time-0.2, {alpha:0}, "start+=0.88")

         tl.set(this.jul.letter.letter4, {x:x4, y:yb, alpha:0}, "start");
         tl.to(this.jul.letter.letter4 , time+0.3, {x:x4, y:yb, alpha:1,ease: CustomEase.create("custom", "M0,0,C0,0.27,0.028,0.626,0.164,0.778,0.285,0.913,0.422,0.974,1,1")}, "start+=0.6")
         tl.to(this.jul.letter.letter4 , time-0.3, {alpha:0}, "start+=0.78")

         tl.set(this.jul.letter.letter5, {x:x5, y:yb, alpha:1}, "start");
         tl.to(this.jul.letter.letter5 ,  time, {x:x5, y:yb, alpha:1,ease: CustomEase.create("custom", "M0,0,C0.01,0.406,0,0.708,0.136,0.86,0.257,0.995,0.308,1,1,1")}, "start+=0.4")
         tl.to(this.jul.letter.letter5 ,  time, {alpha:0}, "start+=0.68")


         // ------------ litter---------
        }

        // actions tween:
        this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));*/

        // logo_mc
        this.jul = new lib.jul();
        this.jul.name = "jul";
        this.jul.parent = this;
        this.jul.setTransform(800, 670);

        this.timeline.addTween(cjs.Tween.get(this.jul).wait(1));

    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(593.1, 768.1, 906.9, 306.9);
// library properties:
    lib.properties = {
        id: 'CF07A2142ADA401E9DA4E5A26203859F',
        width: 1250,
        height: 1250,
        fps: 60,
        color: "#FFFFFF",
        opacity: 1.00,
        manifest: [
            {src:"images/Bitmap1.png", id:"Bitmap1"},
            {src:"images/Bitmap1_1.png", id:"Bitmap1_1"},
            {src:"images/cherep1.png", id:"cherep1"},
            {src:"images/cherep2.png", id:"cherep2"},
            {src:"images/cherep3.png", id:"cherep3"},
            {src:"images/cherep4.png", id:"cherep4"},
            {src:"images/granata.png", id:"granata"},
            {src:"images/Mask_fox.png", id:"Mask_fox"}
        ],
        preloads: []
    };



// bootstrap callback support:

    (lib.Stage = function(canvas) {
        createjs.Stage.call(this, canvas);
    }).prototype = p = new createjs.Stage();

    p.setAutoPlay = function(autoPlay) {
        this.tickEnabled = autoPlay;
    }
    p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
    p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
    p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
    p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

    p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

    an.bootcompsLoaded = an.bootcompsLoaded || [];
    if(!an.bootstrapListeners) {
        an.bootstrapListeners=[];
    }

    an.bootstrapCallback=function(fnCallback) {
        an.bootstrapListeners.push(fnCallback);
        if(an.bootcompsLoaded.length > 0) {
            for(var i=0; i<an.bootcompsLoaded.length; ++i) {
                fnCallback(an.bootcompsLoaded[i]);
            }
        }
    };

    an.compositions = an.compositions || {};
    an.compositions['CF07A2142ADA401E9DA4E5A26203859F'] = {
        getStage: function() { return exportRoot.getStage(); },
        getLibrary: function() { return lib; },
        getSpriteSheet: function() { return ss; },
        getImages: function() { return img; }
    };

    an.compositionLoaded = function(id) {
        an.bootcompsLoaded.push(id);
        for(var j=0; j<an.bootstrapListeners.length; j++) {
            an.bootstrapListeners[j](id);
        }
    }

    an.getComposition = function(id) {
        return an.compositions[id];
    }


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});

// export const AdobeAn = AdobeAn;
export const composition = AdobeAn.getComposition('CF07A2142ADA401E9DA4E5A26203859F');